/* eslint-disable react-hooks/exhaustive-deps */
import {Link} from 'react-router-dom'
import {useContext, useEffect, useState} from 'react'
import {KTSVG} from '../../../../_metronic/helpers'
import {ProjectsListPageContext} from '../../context'
import ProjectMembersListingModal from '../modals/ProjectMembersListingModal'
import Date from '../../../../components/Date/Date'
import Checkbox from '../../../../components/CheckBox/CheckBox'

const ArchivedProjectsTableRow = ({row, actionComponent}: any) => {
  const {addProjectToFavorite, updateProjectDetails, isLoading} =
    useContext(ProjectsListPageContext)

  const [isFavorite, setIsFavorite] = useState(row?.isFevorite === 1 ? true : false)
  const [showModal, setShowModal] = useState(false)
  const [isNotificationEnabled, setIsNotificationEnabled] = useState(false)

  useEffect(() => {
    if (!isLoading && !isNotificationEnabled && row?.isNotificationEnabled) {
      setIsNotificationEnabled(true)
    }
  }, [row?.isNotificationEnabled, isLoading])

  const handleFavorite = () => {
    setIsFavorite(!isFavorite)
    addProjectToFavorite(row?.id)
  }

  const handleNotificationCheckboxChange = () => {
    setIsNotificationEnabled(!isNotificationEnabled)
    updateProjectDetails(
      {is_notification_enabled: !isNotificationEnabled},
      row?.id,
      {is_notification_enabled: true},
      () => {}
    )
  }

  return (
    <tr>
      <td>
        <div className='project-table-name-col'>
          <div className='d-flex align-items-center'>
            <div
              onClick={handleFavorite}
              className={`min-w-25px rating-label me-2 ${isFavorite ? 'checked' : ''}`}
            >
              <KTSVG
                path='/media/icons/duotune/general/gen029.svg'
                className='svg-icon svg-icon-2 me-1 cursor-pointer'
              />
            </div>
            <Link
              to={`/projects/all-projects/${row?.id}`}
              className='text-gray-800 text-hover-primary'
            >
              {row?.name}
            </Link>
          </div>
        </div>
      </td>
      <td>{row?.businessUnit}</td>
      <td
        className='text-center cursor-pointer text-decoration-underline text-hover-primary'
        onClick={() => setShowModal(true)}
      >
        {row?.members}
      </td>
      <td>{row?.ownerName}</td>
      <td>
        <Date date={row['createdAt']} />
      </td>
      {/* <td>
        <Date date={row['updatedAt']} />
      </td> */}
      <td>
        <div className='d-flex justify-content-center'>
          <Checkbox
            id='notifications'
            checked={isNotificationEnabled}
            onChange={handleNotificationCheckboxChange}
          />
        </div>
      </td>
      {actionComponent && <td>{actionComponent(row)}</td>}

      {showModal && (
        <ProjectMembersListingModal
          show={showModal}
          onClose={() => setShowModal(false)}
          projectId={row?.id}
        />
      )}
    </tr>
  )
}

export default ArchivedProjectsTableRow
